import { FirestoreReference } from '../types'

export function extractSegmentsFromFirestoreReference(
  ref: FirestoreReference,
): string[] {
  return ref._key.path.segments
}

export function createFirestoreQueryChunks<T>(
  array: T[] = [],
  size: number = 10, // Firestore limit for "in", "not-in", "array-contains-any" queries is 10
): T[][] {
  const chunks: T[][] = []

  if (!array.length) {
    return chunks
  }

  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size))
  }

  return chunks
}
